/**
 * Get score variant based on value
 * @param score - Score value (0-100)
 * @returns Variant type for styling
 */
export const getScoreVariant = (
  score: number
): 'danger' | 'warning' | 'success' | 'default' => {
  if (score >= 80) return 'success'
  if (score >= 60) return 'default'
  if (score >= 40) return 'warning'
  return 'danger'
}

/**
 * Validate polygon coordinates structure
 * @param coordinates - Raw polygon coordinates
 * @returns true if coordinates are valid
 */
export const isValidPolygonStructure = (coordinates: any): boolean => {
  return (
    Array.isArray(coordinates) &&
    coordinates.length > 0 &&
    Array.isArray(coordinates[0]) &&
    coordinates[0].length >= 4
  )
}

/**
 * Check if coordinates are a coordinate pair [lon, lat]
 * @param coord - Coordinate to check
 * @returns true if valid coordinate pair
 */
export const isCoordinatePair = (coord: any): boolean => {
  return (
    Array.isArray(coord) && coord.length === 2 && typeof coord[0] === 'number'
  )
}
